import { getBackOfficeEntityDataSource } from './index';
import type { IInwinkEntityDataSourceOptions } from '@@api/base/datasource';

export function eventEntityViewDataSource(eventid: string, options?: IInwinkEntityDataSourceOptions) {
    return getBackOfficeEntityDataSource<any>(eventid + "/", "evententityview", "EventEntityView", options);
}
